import { convertToSeconds } from "./convertToSeconds";

export function checkSessionExpiration(duration: string, lastMessageTimestamp: number, _lastTimestamp: number): boolean {
    const durationMs = convertToSeconds(duration) * 1000;

    // never if no session duration in config
    if (!duration) {
        return false;
    }
 
    // TODO: Why? Let's use the time passed since the last message timestamp
    // return lastTimestamp - lastMessageTimestamp > durationMs;
    
    return +new Date() - lastMessageTimestamp > durationMs;
}